import type { FC } from "react";

export type TEnvelopeDotColor = "red" | "green" | "yellow";

interface Props {
  type: TEnvelopeDotColor | null;
}

export const EnvelopeDot: FC<Props> = ({ type }) => {
  if (!type) return null;

  let envelopeColor;

  switch (type) {
    case "green":
      envelopeColor = "#27AE60";
      break;
    case "yellow":
      envelopeColor = "#F2994A";
      break;
    case "red":
      envelopeColor = "#EB5757";
      break;
    default:
      envelopeColor = "#2296B9";
  }

  const styles = {
    marginTop: "-1px",
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: envelopeColor,
    display: "inline-block",
  };

  return <div style={styles} />;
};
